export const environment = {
    production: true,
    environmentName: 'development',
    baseUrl:'https://dev.spellinghero.app/',
    backendUrl:'https://custom-auth-610140353113.northamerica-northeast1.run.app/',
    apiUrl:'https://ui-interaction-2pkagc3btq-nn.a.run.app/',
    region:'northamerica-northeast1',
    recaptchaSiteKey:"6LePWCAqAAAAAHmd-kWC7P4POo6EgGKBu7TZWh1Q",
    stripePublishableKey:"pk_test_51NeMKILUPLIOScuQxCHbwwK7vYeFPqdyhfFxaPsQsENsv6DUA8JpudUPP6BFp785CDoppckJrf9ASZQsUVdQL5TG00F4elkxzw",
    resources: {
        generateUsernamesPdfUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/pdfs%2Fusernames_auto_generate_instructions.pdf?alt=media&token=156ee39b-13c8-4ec8-b3eb-12f4d053c984',
        importUsernamesPdfUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/pdfs%2Fusername_bring_your_own_instructions.pdf?alt=media&token=17218901-1f05-4fb1-9f70-8315f95eac7e',
        cleverPdfUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/pdfs%2FClever-instructions.pdf?alt=media&token=ff1525dc-a23e-486c-97b9-ba77f0871094',
        classlinkPdfUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/pdfs%2FClasslink-instructions.pdf?alt=media&token=199e8cd6-e955-4995-b5da-9f4f2a82681a',
        cleverVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/videos%2Fclever.mp4?alt=media&token=dec0017a-f7af-4877-bef8-a4b40fcb9d6e',
        classlinkVideoUrl: 'https://firebasestorage.googleapis.com/v0/b/spelling-app-d.appspot.com/o/videos%2Fclasslink.mp4?alt=media&token=70bd81f6-53be-4876-9154-777b522b048e',
    },
    firebase: {
        apiKey: "AIzaSyDuoT-lBjL69kpIb0Q27pl2jRqneVmJK3E",
        authDomain: "spelling-app-d.firebaseapp.com",
        projectId: "spelling-app-d",
        storageBucket: "spelling-app-d.appspot.com",
        messagingSenderId: "610140353113",
        appId: "1:610140353113:web:b5645adf819a869e16f748",
        measurementId: "G-5H974DZXPN"
      // ... other Firebase config
    }
  };